<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 mb-3 mb-lg-0">
        <div class="footer__title">Willow Haven Farm</div>
        <p>In the 1740s, Peter Herber settled in this quiet valley near Allentown,
          PA. Here he found fertile land, abundant springs, and a haven for a
          new life. Over two hundred and sixty years later, another farmer and
          his family are producing a bountiful harvest for their friends, family,
          and the wider community of the greater Lehigh Valley.</p>
        <ul class="social-icons">
          <li><a href="https://www.facebook.com/pages/Willow-Haven-Farm/94145588418" target="_blank"
              aria-label="facebook link" class="social-icon"><i class="fab fa-facebook"></i></a></li>
          <li><a href="https://www.instagram.com/willowhavenfarmpa/" target="_blank" aria-label="instagram link"
              class="social-icon"><i class="fab fa-instagram"></i></a></li>
          <li>
            <a class="btn btn-primary"
              href="https://www.google.com/search?q=willowhavenfarmpa&oq=willowhavenfarmpa&ie=UTF-8/#lrd=0x89c434b257a16231:0xd1cb1a45bad945fe,1,,,"
              target="_blank" aria-label="leave a review link">Leave A Review</a>
          </li>
        </ul>
      </div>
      <div class="col-lg-7">
        <div class="row">
          <div class="col-lg-4 offset-lg-1">
            <div class="footer__title">Get In Touch</div>
            <ul class="footer__list">
              <li>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <mask id="mask0_60_547" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18"
                      height="19">
                      <rect y="0.495117" width="18" height="18" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_60_547)">
                      <path
                        d="M9 9.49512C9.4125 9.49512 9.76563 9.34824 10.0594 9.05449C10.3531 8.76074 10.5 8.40762 10.5 7.99512C10.5 7.58262 10.3531 7.22949 10.0594 6.93574C9.76563 6.64199 9.4125 6.49512 9 6.49512C8.5875 6.49512 8.23438 6.64199 7.94063 6.93574C7.64687 7.22949 7.5 7.58262 7.5 7.99512C7.5 8.40762 7.64687 8.76074 7.94063 9.05449C8.23438 9.34824 8.5875 9.49512 9 9.49512ZM9 16.9951C6.9875 15.2826 5.48438 13.692 4.49063 12.2232C3.49688 10.7545 3 9.39512 3 8.14512C3 6.27012 3.60312 4.77637 4.80938 3.66387C6.01563 2.55137 7.4125 1.99512 9 1.99512C10.5875 1.99512 11.9844 2.55137 13.1906 3.66387C14.3969 4.77637 15 6.27012 15 8.14512C15 9.39512 14.5031 10.7545 13.5094 12.2232C12.5156 13.692 11.0125 15.2826 9 16.9951Z"
                        fill="#34511D" />
                    </g>
                  </svg>
                </span>
                7686 Herber Rd,<br>
                New Tripoli, PA 18066
              </li>
              <li>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <mask id="mask0_60_559" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18"
                      height="19">
                      <rect y="0.0849609" width="18" height="18" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_60_559)">
                      <path
                        d="M3 15.085C2.5875 15.085 2.23438 14.9381 1.94063 14.6443C1.64688 14.3506 1.5 13.9975 1.5 13.585V4.58496C1.5 4.17246 1.64688 3.81934 1.94063 3.52559C2.23438 3.23184 2.5875 3.08496 3 3.08496H15C15.4125 3.08496 15.7656 3.23184 16.0594 3.52559C16.3531 3.81934 16.5 4.17246 16.5 4.58496V13.585C16.5 13.9975 16.3531 14.3506 16.0594 14.6443C15.7656 14.9381 15.4125 15.085 15 15.085H3ZM9 9.83496L15 6.08496V4.58496L9 8.33496L3 4.58496V6.08496L9 9.83496Z"
                        fill="#34511D" />
                    </g>
                  </svg>
                </span> farmer&#64;willowhavenfarmpa.com
              </li>
            </ul>
          </div>
          <div class="col-lg-5  offset-lg-1">
            <div class="footer__title">Farm Hours</div>
            <ul class="footer__list">
              <li><label>Friday:</label> 10am - 6pm</li>
              <li><label>Saturday:</label> 9am - 3pm</li>
            </ul>
            <a class="contact-link" href="mailto:farmer@willowhavenfarmpa.com">Contact Us <span
                class="material-symbols-outlined">chevron_right</span></a>
            <a class="contact-link mt-2" href="https://t.me/whfmembersupport" target="_blank">Telegram Support <span
                class="material-symbols-outlined">chevron_right</span></a>
          </div>
          <div class="col-lg-1">
            <div class="to-top" (click)="scrollToTop()">
              <i class="icon fa-solid fa-chevron-up"></i>
              <div class="text">To top</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="terms-bar">
    <a href="https://willowhavenfarmpa.com/terms-conditions"> Terms & Conditions</a> | <a
      href="https://willowhavenfarmpa.com/privacy-policy-2">Privacy Policy</a>
  </div>
  <div class="copy-bar">
    <span class="d-block d-lg-inline">Willow Haven Farm &copy;
      {{copyRightYear}} </span> <span class="d-none d-lg-inline mx-1">|</span><span class="d-block d-lg-inline">Powered
      by <a class="link" href="https://navego.tech" [target]="'_blank'">Navego</a></span>
  </div>
</footer>